import React from 'react';

import type { FallbackImage as FallbackImageProps } from '../../types';

import styles from './FallbackImage.module.scss';

export const FallbackImage = ({ url, width, height }: FallbackImageProps) => {
  return (
    <img
      className={styles.fallbackImage}
      src={url}
      width={width || undefined} // when undefined, CSS will apply
      height={height || undefined} // when undefined, CSS will apply
      alt=""
    />
  );
};
